import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TParameterSetDM from './TParameterSetDM'
import TK2UserLookupDM from './TK2UserLookupDM'
import TWarehouseDM from './TWarehouseDM'
import TTextDM from './TTextDM'
import TBookDM from './TBookDM'
import TTradingPartnerDM from './TTradingPartnerDM'
import FormOfOrder from './FormOfOrder'
import TCostCentreCollectionDocumentDM from './TCostCentreCollectionDocumentDM'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'
import TElectronicAddressTypeDM from './TElectronicAddressTypeDM'
import TOrgStrTreeDM from './TOrgStrTreeDM'
import TCountryDM from './TCountryDM'
import TEshopCategoryInfoDM from './TEshopCategoryInfoDM'
import TShippingMethodDM from './TShippingMethodDM'
import TPriceGroupDM from './TPriceGroupDM'
import TCurrencyDM from './TCurrencyDM'
import TMarketingActivityTypeDM from './TMarketingActivityTypeDM'
import TActivityDM from './TActivityDM'
import TLinkDM from './TLinkDM'
import TCommentDM from './TCommentDM'
import TEshopDeliveryPaymentDM from './TEshopDeliveryPaymentDM'
import TEshopCalculatedStatisticsDM from './TEshopCalculatedStatisticsDM'
import TEshopParameterValueDM from './TEshopParameterValueDM'
import TEshopCategoryAsItemDM from './TEshopCategoryAsItemDM'
import TEshopExposedArticleDM from './TEshopExposedArticleDM'
import TExternalDocumentItemDM from './TExternalDocumentItemDM'
import TLanguageMemoTranslationDM from './TLanguageMemoTranslationDM'
import TAttachedDocumentDM from './TAttachedDocumentDM'
import TOldNoteDM from './TOldNoteDM'

/**
 * Weby, e-shopy
 */
export default class TEshopDM extends Data {
	public static className = 'TEshopDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = true

	/**
	 * Firma
	 */
	CompanyId?: number

	/**
	 * Změněno
	 */
	ChangedOn?: Date

	/**
	 * Vytvořeno
	 */
	CreatedOn?: Date

	/**
	 * Analytické kódy pro hlavičky
	 */
	PageHeaderAnalyticsId?: string

	/**
	 * Analytické kódy
	 */
	PageAnalyticsId?: string

	/**
	 * Právo na záznam
	 */
	RightGroupId?: number

	/**
	 * Časové razítko
	 */
	TimeStamp?: string

	/**
	 * XMLData
	 */
	XMLData?: string

	/**
	 * Název
	 */
	Name?: string

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Odkaz
	 */
	PictureCalc?: string

	/**
	 * URL
	 */
	UrlCalc?: string

	/**
	 * Zákaznické ceny
	 */
	UseTradingPartnerPriceCalc?: string

	/**
	 * undefined
	 */
	PriceGroupToUseCalc?: string

	/**
	 * undefined
	 */
	CurrencyToUseCalc?: string

	/**
	 * undefined
	 */
	LanguagesToUseCalc?: string

	/**
	 * undefined
	 */
	DeliveryCountriesCalc?: string

	/**
	 * undefined
	 */
	InvoiceCountriesCalc?: string

	/**
	 * undefined
	 */
	ConfigDefaultOptionsCalc?: string

	/**
	 * undefined
	 */
	SearchedFieldCalc?: string

	/**
	 * E-mail
	 */
	EmailAddressCalc?: string

	/**
	 * Název odesílatele
	 */
	EmailNameCalc?: string

	/**
	 * Telefon
	 */
	PhoneNumberCalc?: string

	/**
	 * Mobil
	 */
	MobileNumberCalc?: string

	/**
	 * undefined
	 */
	BranchesCalc?: string

	/**
	 * undefined
	 */
	ConfigPaymentGatewaysCalc?: string

	/**
	 * undefined
	 */
	ConfigStatusesCalc?: string

	/**
	 * undefined
	 */
	ConfigSpecificPagesCalc?: string

	/**
	 * undefined
	 */
	ConfigAnalyticToolsCalc?: string

	/**
	 * undefined
	 */
	ConfigUsersCalc?: string

	/**
	 * undefined
	 */
	ConfigPagesCalc?: string

	/**
	 * undefined
	 */
	ConfigArticleListCalc?: string

	/**
	 * undefined
	 */
	ConfigArticleDetailCalc?: string

	/**
	 * undefined
	 */
	ConfigBasketCalc?: string

	/**
	 * undefined
	 */
	ConfigTestingCalc?: string

	/**
	 * undefined
	 */
	ConfigInsertedContentCalc?: string

	/**
	 * undefined
	 */
	ConfigRecordsTypesCalc?: string

	/**
	 * undefined
	 */
	ConfigBookmarksCalc?: string

	/**
	 * undefined
	 */
	ShowServiceCategoryCalc?: string

	/**
	 * undefined
	 */
	ConfigDocumentFilterCalc?: string

	/**
	 * undefined
	 */
	UrlAbsCalc?: string

	/**
	 * undefined
	 */
	ConfigEmailActionsCalc?: string

	/**
	 * undefined
	 */
	ConfigQuotationsCalc?: string

	/**
	 * undefined
	 */
	ConfigFulltextSearchCalc?: string

	/**
	 * undefined
	 */
	CompanyIdDeprecatedCalc?: number

	/**
	 * Web verze
	 */
	WebVersionIdCalc?: number

	/**
	 * Způsob dopravy
	 */
	TransportMethodRIDCalc?: number

	/**
	 * undefined
	 */
	ConfigImmediatePaymentCalc?: string

	/**
	 * undefined
	 */
	ConfigOtherSettingsCalc?: string

	/**
	 * undefined
	 */
	OwnSortListCalc?: string

	/**
	 * undefined
	 */
	AdminListCalc?: string

	/**
	 * undefined
	 */
	BranchConfigCalc?: string

	/**
	 * undefined
	 */
	TextHeaderMemoCalc?: string

	/**
	 * undefined
	 */
	TextFooterMemoCalc?: string

	/**
	 * Poslední komentář
	 */
	LastCommentParamCalc?: string

	/**
	 * Právo na záznam
	 */
	RightGroupIdCalc?: number

	/**
	 * Zařazení parametrů
	 */
	@Type(() => TParameterSetDM)
	ParameterSetId?: TParameterSetDM

	/**
	 * Změnil
	 */
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM

	/**
	 * Vytvořil
	 */
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM

	/**
	 * Sklad
	 */
	@Type(() => TWarehouseDM)
	WarehouseId?: TWarehouseDM

	/**
	 * Z
	 */
	@Type(() => TTextDM)
	InvalidRecordImgCalc?: TTextDM

	/**
	 * Kniha zakázky
	 */
	@Type(() => TBookDM)
	SalesOrderBookIdCalc?: TBookDM

	/**
	 * Zákazník
	 */
	@Type(() => TTradingPartnerDM)
	SalesOrderTradingPartnerIdCalc?: TTradingPartnerDM

	/**
	 * Způsob objednávky
	 */
	@Type(() => FormOfOrder)
	OrderFormCalc?: FormOfOrder

	/**
	 * Středisko
	 */
	@Type(() => TCostCentreCollectionDocumentDM)
	CostCentreIdCalc?: TCostCentreCollectionDocumentDM

	/**
	 * Kód zakázky
	 */
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRIDCalc?: TContractCodeDocumentDM

	/**
	 * Výdejní sklad
	 */
	@Type(() => TWarehouseDM)
	WarehouseOutIdCalc?: TWarehouseDM

	/**
	 * Typ el. adresy pro email
	 */
	@Type(() => TElectronicAddressTypeDM)
	ElectronicAddressEmailTypeIdCalc?: TElectronicAddressTypeDM

	/**
	 * Typ el. adresy pro telefon
	 */
	@Type(() => TElectronicAddressTypeDM)
	ElectronicAddressPhoneTypeIdCalc?: TElectronicAddressTypeDM

	/**
	 * Strom org. struktury
	 */
	@Type(() => TOrgStrTreeDM)
	OrgStrRIDCalc?: TOrgStrTreeDM

	/**
	 * Vých. stát (dodání)
	 */
	@Type(() => TCountryDM)
	DefaultDeliveryCountryIdCalc?: TCountryDM

	/**
	 * Vých. stát (faktury)
	 */
	@Type(() => TCountryDM)
	DefaultIvoiceCountryIdCalc?: TCountryDM

	/**
	 * Kategorie pro strom
	 */
	@Type(() => TEshopCategoryInfoDM)
	DefaultTreeCategoryRIDCalc?: TEshopCategoryInfoDM

	/**
	 * Servisní kategorie
	 */
	@Type(() => TEshopCategoryInfoDM)
	ServiceCategoryRIDCalc?: TEshopCategoryInfoDM

	/**
	 * undefined
	 */
	@Type(() => TEshopCategoryInfoDM)
	CalcStatisticByCategoryRIDCalc?: TEshopCategoryInfoDM

	/**
	 * Způsob odběru
	 */
	@Type(() => TShippingMethodDM)
	ShippingMethodIdCalc?: TShippingMethodDM

	/**
	 * Firma
	 */
	@Type(() => TTradingPartnerDM)
	ShownTradingPartnerIdCalc?: TTradingPartnerDM

	/**
	 * Cenová sk.
	 */
	@Type(() => TPriceGroupDM)
	ShownPriceGroupIdCalc?: TPriceGroupDM

	/**
	 * Měna
	 */
	@Type(() => TCurrencyDM)
	ShownCurrencyCalc?: TCurrencyDM

	/**
	 * D
	 */
	@Type(() => TTextDM)
	DocumentExistsCalc?: TTextDM

	/**
	 * undefined
	 */
	@Type(() => TMarketingActivityTypeDM)
	ActivityTypeRIDCalc?: TMarketingActivityTypeDM

	/**
	 * undefined
	 */
	@Type(() => TActivityDM)
	ActivityIdCalc?: TActivityDM

	/**
	 * Odkazy
	 */
	@Type(() => TLinkDM)
	LinkChild?: TLinkDM[]

	/**
	 * Komentáře
	 */
	@Type(() => TCommentDM)
	CommentChild?: TCommentDM[]

	/**
	 * undefined
	 */
	@Type(() => TEshopCategoryInfoDM)
	CategoryChild?: TEshopCategoryInfoDM[]

	/**
	 * undefined
	 */
	@Type(() => TEshopDeliveryPaymentDM)
	DeliveryPaymentChild?: TEshopDeliveryPaymentDM[]

	/**
	 * undefined
	 */
	@Type(() => TEshopCalculatedStatisticsDM)
	CalculatedStatisticsChild?: TEshopCalculatedStatisticsDM[]

	/**
	 * undefined
	 */
	@Type(() => TEshopParameterValueDM)
	ParameterValueChild?: TEshopParameterValueDM[]

	/**
	 * undefined
	 */
	@Type(() => TEshopCategoryAsItemDM)
	CategoryTreeChild?: TEshopCategoryAsItemDM[]

	/**
	 * undefined
	 */
	@Type(() => TEshopExposedArticleDM)
	ExposedArticleChild?: TEshopExposedArticleDM[]

	/**
	 * Seznam aktivit
	 */
	@Type(() => TActivityDM)
	ActivityChild?: TActivityDM[]

	/**
	 * Dokumenty
	 */
	@Type(() => TExternalDocumentItemDM)
	ExternalDocumentItemChild?: TExternalDocumentItemDM[]

	/**
	 * Text hlavičky
	 */
	@Type(() => TLanguageMemoTranslationDM)
	TextHeaderChild?: TLanguageMemoTranslationDM[]

	/**
	 * Text patičky
	 */
	@Type(() => TLanguageMemoTranslationDM)
	TextFooterChild?: TLanguageMemoTranslationDM[]

	/**
	 * Svázané doklady
	 */
	@Type(() => TAttachedDocumentDM)
	AttachedDocumentOldChild?: TAttachedDocumentDM[]

	/**
	 * Poznámky
	 */
	@Type(() => TOldNoteDM)
	DeprecatedNoteOldChild?: TOldNoteDM[]

	/**
	 * Zneplatnění
	 */
	public BulkInvalidationCOMMAND() {
		return this.executeCommand('BulkInvalidationCOMMAND')
	}

	/**
	 * Zplatnění
	 */
	public BulkUnInvalidationCOMMAND() {
		return this.executeCommand('BulkUnInvalidationCOMMAND')
	}

	/**
	 * Zneplatnění/Zplatnění
	 */
	public InvalidationCOMMAND() {
		return this.executeCommand('InvalidationCOMMAND')
	}

	/**
	 * Potvrzení
	 */
	public BulkConfirmCOMMAND() {
		return this.executeCommand('BulkConfirmCOMMAND')
	}

	/**
	 * Odpotvrzení
	 */
	public BulkUnconfirmCOMMAND() {
		return this.executeCommand('BulkUnconfirmCOMMAND')
	}

	/**
	 * Změna data potvrzení
	 */
	public BulkChangeConfirmationDateCOMMAND(parameters: TBulkChangeConfirmationDateCOMMANDParams) {
		return this.executeCommand('BulkChangeConfirmationDateCOMMAND', parameters)
	}

	/**
	 * Storno
	 */
	public BulkCancelCOMMAND() {
		return this.executeCommand('BulkCancelCOMMAND')
	}

	/**
	 * Odstorno
	 */
	public BulkUnCancelCOMMAND() {
		return this.executeCommand('BulkUnCancelCOMMAND')
	}

	/**
	 * Potvrzení
	 */
	public ConfirmCOMMAND() {
		return this.executeCommand('ConfirmCOMMAND')
	}

	/**
	 * Odpotvrzení
	 */
	public UnconfirmCOMMAND() {
		return this.executeCommand('UnconfirmCOMMAND')
	}

	/**
	 * Změna data potvrzení
	 */
	public ChangeConfirmationDateCOMMAND(parameters: TChangeConfirmationDateCOMMANDParams) {
		return this.executeCommand('ChangeConfirmationDateCOMMAND', parameters)
	}

	/**
	 * Storno/Odstorno
	 */
	public CancelCOMMAND() {
		return this.executeCommand('CancelCOMMAND')
	}

	/**
	 * Zrušení stavu
	 */
	public ClearRecordStatusCOMMAND() {
		return this.executeCommand('ClearRecordStatusCOMMAND')
	}

	/**
	 * Změna stavu
	 */
	public ChangeRecordStatusCOMMAND() {
		return this.executeCommand('ChangeRecordStatusCOMMAND')
	}

	/**
	 * 
	 */
	public ChangeRecordStatusSWSCOMMAND(parameters: TChangeRecordStatusSWSCOMMANDParams) {
		return this.executeCommand('ChangeRecordStatusSWSCOMMAND', parameters)
	}

	/**
	 * Zrušení stavu
	 */
	public BulkClearRecordStatusCOMMAND() {
		return this.executeCommand('BulkClearRecordStatusCOMMAND')
	}

	/**
	 * Změna stavu
	 */
	public BulkChangeRecordStatusCOMMAND() {
		return this.executeCommand('BulkChangeRecordStatusCOMMAND')
	}

	/**
	 * Změna atributů
	 */
	public BulkChangeAttributesCOMMAND(parameters: TBulkChangeAttributesCOMMANDParams) {
		return this.executeCommand('BulkChangeAttributesCOMMAND', parameters)
	}

	/**
	 * Aktualizace sady atributů
	 */
	public BulkActualizeAttributesCOMMAND(parameters: TBulkActualizeAttributesCOMMANDParams) {
		return this.executeCommand('BulkActualizeAttributesCOMMAND', parameters)
	}

	/**
	 * Aktualizace sady atributů
	 */
	public ActualizeAttributesCOMMAND() {
		return this.executeCommand('ActualizeAttributesCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public ChangeGroupRightCOMMAND() {
		return this.executeCommand('ChangeGroupRightCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public BulkChangeGroupRightCOMMAND() {
		return this.executeCommand('BulkChangeGroupRightCOMMAND')
	}

	/**
	 * Aktualizace počítaných polí
	 */
	public BulkUpdateCalcFieldsCOMMAND() {
		return this.executeCommand('BulkUpdateCalcFieldsCOMMAND')
	}

	/**
	 * Kontrola legislativy
	 */
	public SwitchOffLegislationValidationCOMMAND() {
		return this.executeCommand('SwitchOffLegislationValidationCOMMAND')
	}
}

export type TBulkChangeConfirmationDateCOMMANDParams = {
	/**
	 * Datum potvrzení
	 */
	Confirmation1Date?: Date
	/**
	 * Hodina potvrzení
	 */
	Confirmation1Time?: Date
	/**
	 * Datum 2. potvrzení
	 */
	Confirmation2Date?: Date
	/**
	 * Hodina 2. potvrzení
	 */
	Confirmation2Time?: Date
	/**
	 * Kontrolovat záporné stavy
	 */
	CheckNegativeState?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}

export type TChangeConfirmationDateCOMMANDParams = {
	/**
	 * Datum potvrzení
	 */
	Confirmation1Date?: Date
	/**
	 * Hodina potvrzení
	 */
	Confirmation1Time?: Date
	/**
	 * Datum 2. potvrzení
	 */
	Confirmation2Date?: Date
	/**
	 * Hodina 2. potvrzení
	 */
	Confirmation2Time?: Date
	/**
	 * Kontrolovat záporné stavy
	 */
	CheckNegativeState?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}

export type TChangeRecordStatusSWSCOMMANDParams = {
	/**
	 * StatusId
	 */
	StatusId?: number
}

export type TBulkChangeAttributesCOMMANDParams = {
	/**
	 * Smazat atributy
	 */
	DeleteAttribute?: boolean
	/**
	 * Smazat všechny volné atributy
	 */
	DeleteFreeAttribute?: boolean
	/**
	 * Nastavit hodnoty atributů
	 */
	SetValues?: boolean
	/**
	 * Přidat nepřipojené atributy
	 */
	AddFreeAttributes?: boolean
	/**
	 * FreeAttributeEnabled
	 */
	FreeAttributeEnabled?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}

export type TBulkActualizeAttributesCOMMANDParams = {
	/**
	 * Aktualizovat včetně samotné sady atributů
	 */
	ActualizeAttributeSet?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}